import script from "./ViewQuestionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewQuestionView.vue?vue&type=script&lang=ts&setup=true"

import "./ViewQuestionView.vue?vue&type=style&index=0&id=027c8d20&lang=css"

const __exports__ = script;

export default __exports__